import settings from '@/settings'

let listar = (headers, posto) => {
  return fetch(`${settings.apetrusApi}/convenios/?posto=${posto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let detalhar = (headers, posto, id) => {
  return fetch(`${settings.apetrusApi}/convenios/${id}/?posto=${posto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let atualizar = (headers, posto, id, data) => {
  return fetch(`${settings.apetrusApi}/convenios/${id}/?posto=${posto}`, {
    method: 'PATCH',
    mode: 'cors',
    cache: 'default',
    headers: headers,
    body: JSON.stringify(data)
  })
}

let inserir = (headers, data, posto) => {
  return fetch(`${settings.apetrusApi}/convenios/?posto=${posto}`, {
    method: 'POST',
    mode: 'cors',
    cache: 'default',
    body: JSON.stringify(data),
    headers: headers
  })
}

let apagar = (headers, posto, id) => {
  return fetch(`${settings.apetrusApi}/convenios/${id}/?posto=${posto}`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const solicitacoesConvenio = (headers, posto) => {
  return fetch(`${settings.apetrusApi}/convenio/convenioposto/?posto=${posto}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const aceitarSolicitacao = (headers, posto, data) => {
  return fetch(`${settings.apetrusApi}/convenio/convenioposto/?posto=${posto}`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    headers: headers
  })
}

const pegarConveniados = (headers, filtros) => {
  let url = `${settings.apetrusApi}/convenio/conveniadosporposto/`
  if (filtros) {
    Object.keys(filtros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${filtros[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  listar,
  detalhar,
  inserir,
  atualizar,
  apagar,
  solicitacoesConvenio,
  aceitarSolicitacao,
  pegarConveniados
}
